/* Tidel: overflow arrow for the "What's New at Tidel" tab row.
   Not part of Ella.

   Adds a circular "scroll right" button to the tab row of the section whose
   colour scheme is scheme-10 (the tabbed product slider). The button is only
   revealed while the row actually overflows and is not already scrolled to the
   end; CSS hides it entirely below 750px, where swiping is enough. */
(function () {
  'use strict';

  var SECTION = '.color-scheme-10';
  var WRAPPER = '.tabs-product-header-wrapper';
  var ROW = '.tabs-product-header';
  var FLAG = 'tidelTabScroll';
  var OVERFLOW_CLASS = 'tidel-tabs--overflow';

  var ARROW =
    '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">' +
    '<path d="M9 5l7 7-7 7" stroke="currentColor" stroke-width="2" ' +
    'stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function setup(wrapper) {
    if (wrapper.dataset[FLAG]) return;
    var row = wrapper.querySelector(ROW);
    if (!row) return;
    wrapper.dataset[FLAG] = '1';

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'tidel-tabs-next';
    button.setAttribute('aria-label', 'Scroll tabs right');
    button.innerHTML = ARROW;
    wrapper.appendChild(button);

    function update() {
      var overflowing = row.scrollWidth - row.clientWidth > 2;
      var atEnd = row.scrollLeft + row.clientWidth >= row.scrollWidth - 2;
      wrapper.classList.toggle(OVERFLOW_CLASS, overflowing && !atEnd);
    }

    button.addEventListener('click', function () {
      row.scrollBy({ left: Math.round(row.clientWidth * 0.6), behavior: 'smooth' });
    });

    row.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    // Pills can change width once webfonts land, so re-measure when they do.
    if (typeof ResizeObserver === 'function') {
      new ResizeObserver(update).observe(row);
    } else if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(update);
    }

    update();
  }

  function boot() {
    var wrappers = document.querySelectorAll(SECTION + ' ' + WRAPPER);
    for (var i = 0; i < wrappers.length; i++) setup(wrappers[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  // Re-run when the theme editor re-renders a section.
  document.addEventListener('shopify:section:load', boot);
})();
